import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './home/Home';
import { Forward } from './home/Forward';

export const Router = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/fw/:saleId' element={<Forward />} />
                <Route path='/:slug' element={<Home />} />
                <Route path='*' element={<Home />} />
            </Routes>
        </BrowserRouter>
    );
};